/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Resume_Perf_Col_OffersInputs */

const en_analytics_resume_perf_col_offers = /** @type {(inputs: Analytics_Resume_Perf_Col_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offers`)
};

const de_analytics_resume_perf_col_offers = /** @type {(inputs: Analytics_Resume_Perf_Col_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angebote`)
};

const fr_analytics_resume_perf_col_offers = /** @type {(inputs: Analytics_Resume_Perf_Col_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offres`)
};

const es_analytics_resume_perf_col_offers = /** @type {(inputs: Analytics_Resume_Perf_Col_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas`)
};

const it_analytics_resume_perf_col_offers = /** @type {(inputs: Analytics_Resume_Perf_Col_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offerte`)
};

const nl_analytics_resume_perf_col_offers = /** @type {(inputs: Analytics_Resume_Perf_Col_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aanbiedingen`)
};

const pl_analytics_resume_perf_col_offers = /** @type {(inputs: Analytics_Resume_Perf_Col_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferty`)
};

const fi_analytics_resume_perf_col_offers = /** @type {(inputs: Analytics_Resume_Perf_Col_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarjoukset`)
};

const da_analytics_resume_perf_col_offers = /** @type {(inputs: Analytics_Resume_Perf_Col_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilbud`)
};

const sv_analytics_resume_perf_col_offers = /** @type {(inputs: Analytics_Resume_Perf_Col_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erbjudanden`)
};

/**
* | output |
* | --- |
* | "Offers" |
*
* @param {Analytics_Resume_Perf_Col_OffersInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_resume_perf_col_offers = /** @type {((inputs?: Analytics_Resume_Perf_Col_OffersInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Resume_Perf_Col_OffersInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_resume_perf_col_offers(inputs)
	if (locale === "fr") return fr_analytics_resume_perf_col_offers(inputs)
	if (locale === "es") return es_analytics_resume_perf_col_offers(inputs)
	if (locale === "it") return it_analytics_resume_perf_col_offers(inputs)
	if (locale === "nl") return nl_analytics_resume_perf_col_offers(inputs)
	if (locale === "pl") return pl_analytics_resume_perf_col_offers(inputs)
	if (locale === "fi") return fi_analytics_resume_perf_col_offers(inputs)
	if (locale === "da") return da_analytics_resume_perf_col_offers(inputs)
	if (locale === "sv") return sv_analytics_resume_perf_col_offers(inputs)
	return en_analytics_resume_perf_col_offers(inputs)
});